// extracted by mini-css-extract-plugin
export default {"container":"expenses_main_container__nmJKT","content":"expenses_main_content__I+J2p"};